export default "__VITE_ASSET__0ecd0e62__"